import { useEffect, useState } from 'react';
import TextField from '../text-field/TextField';
import { LocationDTO } from '../../api/api';
import { FormControl } from '@mui/material';
import WorkClient from '../../api/workClient';
import AutoComplete from '../auto-complete/AutoComplete';
import { formatAddressIgnoreFloorAndDoor } from '../../utils/location/locationHandling';

interface Props {
  onSelect: (address: LocationDTO) => void;
  label: string;
  noOptionsText?: string;
  prevLocation?: LocationDTO;
  required?: boolean;
}

const AddressAutocomplete = (props: Props) => {
  const { onSelect, label, noOptionsText, prevLocation, required } = props;

  const [options, setOptions] = useState<LocationDTO[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<LocationDTO | undefined>(prevLocation);

  const addressChangeHandler = async (_searchTerm: string) => {
    const options = await WorkClient.searchAddresses(_searchTerm, true, true);
    const mappedOptions: LocationDTO[] = options.map((obj: any) => {
      // Danadresse returns the full (nested) adgangsadresse structure, not DAWA's flat autocomplete format
      const [longitude, latitude] = obj.adgangspunkt?.koordinater ?? [];
      return {
        city: obj.postnummer?.navn,
        houseNumber: obj.husnr,
        latitude,
        longitude,
        postalCode: obj.postnummer?.nr,
        streetName: obj.vejstykke?.navn
      };
    });
    setOptions(mappedOptions);
  };

  const onAddressSelectedHandler = (_address: LocationDTO | null) => {
    if (!_address) return;
    setSelectedAddress(_address);
    onSelect(_address);
  };

  useEffect(() => {
    prevLocation && onAddressSelectedHandler(prevLocation);
  }, [prevLocation]);

  return (
    <FormControl fullWidth>
      {/* Floor and door is not included in search */}
      <AutoComplete
        noOptionsText={noOptionsText ?? 'Ingen muligheder'}
        id="addresses"
        options={options}
        getOptionLabel={(option) =>
          option.streetName && option.houseNumber && option.postalCode && option.city
            ? ` ${formatAddressIgnoreFloorAndDoor(option)}`
            : ''
        }
        fullWidth
        renderInput={(params) => (
          <TextField
            required={required}
            label={label ?? 'Adresse'}
            onChange={(e) => addressChangeHandler(e.target.value)}
            {...params}
          />
        )}
        value={selectedAddress}
        onChange={(_, value) => onAddressSelectedHandler(value)}
      />
    </FormControl>
  );
};

export default AddressAutocomplete;
